import { IPluginMetadataSucceededResult } from 'app/apis/plugin-metadata-api.service';

import { format } from 'app/shared/utils/string.util';

const connector: IPluginMetadataSucceededResult = {
    connectorName: 'Twilio',
    dataType: 'Hierarchical',
    SupportEncryption: true,
    connectionSettings: [
        {
            type: 'String',
            name: 'userName',
            required: false,
            sensitive: false,
            signature: true
        },
        {
            type: 'String',
            name: 'password',
            required: true,
            sensitive: true,
            signature: false
        }
    ],
    readSettings: [
        {
            type: 'String',
            name: 'resource'
        },
        {
            type: 'String',
            name: 'from'
        },
        {
            type: 'String',
            name: 'to'
        }
    ],
    writeSettings: [],
    adfAppModelConfiguration: {
        displayName: format(stringResources.ModelName_DisplayTextPreviewTemplate, 'Twilio'),
        icon: {
            className: 'svg-i-100x100-twilio'
        },
        category: ['ServicesApps'],
        linkedService: {
            properties: [
                'userName',
                'password'
            ],
            uiControls: [
                {
                    bind: 'userName',
                    controlType: 'TextBox',
                    displayName: stringResources.Account_SID
                },
                {
                    bind: 'password',
                    controlType: 'TextBox',
                    displayName: stringResources.Auth_Token
                }
            ]
        },
        dataflowInlineSource: {
            properties: [
                'resource',
                'from',
                'to'
            ],
            uiControls: [
                {
                    bind: 'resource',
                    controlType: 'DropDown',
                    displayName: stringResources.Resource,
                    required: true,
                    defaultValue: 'Messages',
                    controlSettings: {
                        options: [
                            { label: stringResources.Messages, value: 'Messages' },
                            { label: stringResources.Calls, value: 'Calls' }
                        ]
                    }
                },
                {
                    bind: 'from',
                    controlType: 'TextBox',
                    displayName: stringResources.From,
                    description: stringResources.DataFlow_Twilio_Phone_Description
                },
                {
                    bind: 'to',
                    controlType: 'TextBox',
                    displayName: stringResources.To,
                    description: stringResources.DataFlow_Twilio_Phone_Description
                }
            ],
            itemSettings: {
                dataflowType: 'twilio',
                dataflowUseInlineProjection: true,
                dataflowFormat: 'rest'
            }
        }
    }
};

export default connector;
